import { message } from "antd";
import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useDataLayerValue } from "../../../DataLayer/DataLayer";
import Layout from "../../../Layout";
import HeaderBread from "../../../components/HeaderBread";
import CustomHeaderTitle from "../../../components/constants/CustomHeaderTitle";
import ActiveSwitchFile from "../../../components/SwitchFile";
import CustomizedTable from "../../../components/UI/CustomizedTable";
import { constants } from "../../../constants/constants";
import DeletePop from "../../../constants/ErrorPermissionModal";
import { deletePopupData, getPopupData, updatePopupData } from "../../../utils/ApiCalls/Popup";
import { addlog } from "../../../utils/ApiCalls/Logs";
import { checkPermission } from "../../../utils/Validation/checkPermission";
import { LOG_ACTIONS } from "../../../utils/Constant/LogConstant";
import Logs from "../../../components/Logs";
import SwitchBar from "../../../components/Pages/SwitchBar";
import SearchField from "../../../components/SearchField";
import ActiveInactive from "../../../components/UI/ActiveInactive";
import SelectLocation from "../../../components/LocationFilter";
import ValidDateUI from "../../../constants/validDateUI";
import { getAllLocations } from "../../../utils/ApiCalls/Locations";

const Popup = () => {
  const navigate = useNavigate();
  const [active, setActive] = useState("listing");
  const [regionalActive, setRegionalActive] = useState("SG");
  const [{ userDetails, permission }, dispatch] = useDataLayerValue();
  const [rows, setRows] = useState([]);
  const [count, setCount] = useState(0);
  const [refreshlog, setRefreshLog] = useState(true);
  const [sort, setSort] = useState("");
  const [order, setOrder] = useState("");
  const [status, setStatus] = useState("");
  const [location, setLocation] = useState();
  const [locationOption, setLocationOption] = useState([]);


  const locationP = useLocation();
  const [page, setPage] = useState(
    () => parseInt(new URLSearchParams(locationP.search).get("page")) || 1
  );
  const [pageSize, setPageSize] = useState(
    () => parseInt(new URLSearchParams(locationP.search).get("pageSize")) || 10
  );
  const [search, setSearch] = useState(
    () => new URLSearchParams(locationP.search).get("search") || ""
  );

  const navigation = [
    { title: "Home", route: "/" },
    { title: "Popup List", route: "/website/webpages/popup" },
  ];

  useEffect(() => {
    getLocationData();
  }, []);
  const getLocationData = async () => {
    let data = await getAllLocations();
    setLocationOption(data?.data || []);
  };

  useEffect(() => {
    const params = new URLSearchParams(locationP.search);
    setSearch(params.get("search") || "");
  }, [locationP.search]);

  useEffect(() => {
    const params = new URLSearchParams();
    const currentParams = new URLSearchParams(locationP.search);
    params.set("page", page);
    params.set("pageSize", pageSize);
    if (search) params.set("search", search);
    if (currentParams.toString() !== params.toString()) {
      navigate({ search: params.toString() }, { replace: true });
    }
  }, [page, pageSize, search, navigate, locationP.search]);

  useEffect(() => {
    getData(page, sort, order);
  }, [page, pageSize, search]);

  useEffect(() => {
    getData(page, sort, order);
  }, [regionalActive]);

  const getData = async (value, sort, order) => {
    dispatch({ type: "SET_LOADING", loading: true });
    let args = { search, page: value, limit: pageSize };
    if (regionalActive) {
      args = { ...args, location: regionalActive };
    }
    if (location && location !== -1) {
      args = { ...args, location_id: location };
    }
    if (status !== "") {
      args = { ...args, is_active: status };
    }
    if (order) {
      if (sort) args = { ...args, sort };
      args = { ...args, order };
    }
    const data = await getPopupData(args);
    if (data.error) {
      Swal.fire({ icon: "error", title: "Oops...", text: data.error });
    } else if (data.data) {
      setRows(data.data);
      setCount(data.count);
    }
    dispatch({ type: "SET_LOADING", loading: false });
  };

  const sortHandler = async (options) => {
    if (Object.keys(options).length > 0) {
      const s = options.columnKey;
      const o =
        options.order === "ascend"
          ? "asc"
          : options.order === "descend"
          ? "desc"
          : undefined;
      setSort(s);
      setOrder(o);
      await getData(page, s, o);
    }
  };

  const handleEdit = (id) => {
    if (checkPermission(permission, "update_per", "Popup", window?.location?.pathname)) {
      navigate("/website/webpages/popup/edit/" + id);
    } else {
      message.error("Update permission missing");
    }
  };

  const handleDelete = async (id) => {
    if (checkPermission(permission, "delete_per", "Popup", window?.location?.pathname)) {
      await deletePopupData(id);
      addlog("Popup Deleted", "Popup", { id }, userDetails.id);
      setRefreshLog((v) => !v);
      getData(page, sort, order);
    } else {
      message.error("Missing permission for delete");
    }
  };

  const handleUpdate = async (id, values) => {
    if (checkPermission(permission, "update_per", "Popup", window?.location?.pathname)) {
      const data = await updatePopupData(id, values);
      if (data.error) {
        Swal.fire({ icon: "error", title: "Oops...", text: data.error });
      } else {
        addlog(
          "Popup " + (values.is_active === 1 ? LOG_ACTIONS.ACTIVATED : LOG_ACTIONS.DEACTIVATED),
          "Popup",
          { ...values, id },
          userDetails.id
        );
      }
      setRefreshLog((v) => !v);
      getData(page, sort, order);
    } else {
      message.error("Update permission missing");
    }
  };

  const columns = [
    {
      title: "Sl",
      width: 30,
      dataIndex: "id",
      key: "id",
      fixed: "left",
      render: (_, __, index) => (page - 1) * pageSize + index + 1,
    },
    {
      title: "Image",
      width: 10,
      dataIndex: "english_image",
      key: "english_image",
      render: (image) =>
        image ? (
          <img
            alt="popup-en"
            src={`${constants.MEDIAURL}/${image}`}
            style={{ width: "150px", height: "78px", objectFit: "cover" }}
          />
        ) : "—",
    },
    {
      title: "Valid Date",
      key: "valid_date",
      width: 30,
      render: (_, record) =>
        record.valid_from && record.valid_to ? (
          <ValidDateUI
            time={true}
            record={{
              ...record,
              location_id: record.location_id ?? locationOption.find((l) => l.location_code === regionalActive)?.id,
            }}
            handleUpdate={handleUpdate}
            regionalActive={regionalActive}
            locationOption={locationOption}
          />
        ) : "—",
    },
    {
      title: "Status",
      dataIndex: "is_active",
      key: "is_active",
      width: 10,
      render: (item, record, index) => (
        <ActiveSwitchFile
          item={item}
          record={record}
          index={index}
          module={"Popup"}
          handleUpdate={handleUpdate}
        />
      ),
    },
    {
      title: "Action",
      key: "operation",
      width: 10,
      render: (_, record) => (
        <div className="table_action_btn">
          <button className="btn" onClick={() => handleEdit(record.id)}>
            <i className="ri-edit-2-line" data-toggle="tooltip" title="Edit" />
          </button>
          <DeletePop onConfirm={() => handleDelete(record.id)}>
            <div>
              <button className="btn delete_btn">
                <i className="ri-delete-bin-line" data-toggle="tooltip" title="Delete" />
              </button>
            </div>
          </DeletePop>
        </div>
      ),
    },
  ];

  return (
    <Layout type={"read_per"} module_data={"Popup"}>
      <CustomHeaderTitle title={"Popup"} />
      <div>
        <HeaderBread navigation={navigation} title={"Popup"} />
        <section className="content" style={{ marginTop: "20px" }}>
          <div className="container-fluid">
            <SwitchBar
              tabs={[
                { title: "Popup List", value: "listing" },
                { title: "History Logs", value: "logs" },
              ]}
              activeTab={active}
              setActiveTab={setActive}
            />
            {active === "listing" && (
              <div className="card">
                <div className="card-header two_item">
                  <h5 className="card-title">Popup List</h5>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      gap: "5px",
                      width: "80%",
                      justifyContent: "flex-end",
                    }}
                  >
                    {regionalActive === "OTHER" && (
                      <SelectLocation
                        getData={getData}
                        setStatus={setLocation}
                        disabled={regionalActive === "OTHER"}
                        status={location}
                        width={200}
                        setPage={setPage}
                      />
                    )}
                    <ActiveInactive
                      width={200}
                      getData={getData}
                      setStatus={setStatus}
                      status={status}
                      setPage={setPage}
                    />
                    <Link
                      to="/website/webpages/popup/add"
                      className="btn add_v_btn"
                      style={{ width: "200px" }}
                    >
                      Add Popup
                    </Link>
                  </div>
                </div>
                <div className="card-body">
                  <div className="table_holder">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "flex-end",
                        justifyContent: "flex-end",
                      }}
                    >
                    </div>
                    <SwitchBar
                      tabs={[
                        { title: "Singapore", value: "SG" },
                        { value: "MY", title: "Malaysia" },
                        { value: "ID", title: "Indonesia" },
                        { value: "IN", title: "India" },
                        { value: "CN", title: "China" },
                        { value: "TW", title: "Taiwan" },
                        { value: "HK", title: "Hong Kong" },
                        { value: "PH", title: "Philippines" },
                        { value: "AE", title: "UAE" },
                        { value: "OTHER", title: "All Others" },
                      ]}
                      setPageSize={setPageSize}
                      module={"country-tab"}
                      setPage={setPage}
                      setRows={setRows}
                      setCount={setCount}
                      activeTab={regionalActive}
                      setActiveTab={(item) => {
                        setRegionalActive(item);
                        setLocation();
                      }}
                      setSearch={setSearch}
                    />
                    <CustomizedTable
                      setRows={setRows}
                      setPageSize={setPageSize}
                      setPage={setPage}
                      pageSize={pageSize}
                      page={page}
                      count={count}
                      columns={columns}
                      rows={rows}
                      title={"Popup"}
                      sortHandler={sortHandler}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </section>
        {active === "logs" && (
          <Logs
            type={"Popup"}
            slug={"/website/webpages/popup/edit/"}
            refreshlog={refreshlog}
          />
        )}
      </div>
    </Layout>
  );
};

export default Popup;
